import "./IENotSupportedBanner.css";
import React from "react";
import ContentItem from "shared/components/cms/ContentItem";
import { isIE } from "react-device-detect";

class IENotSupportedBanner extends React.Component {
    componentDidMount() {
        this.isIE = Boolean(isIE);
    }

    render() {
        return this.isIE ?
            <ContentItem
                className="ie-not-supported"
                contentKey="ieNotSupportedText"
                sharedKey="ieNotSupportedBanner"
            />
            : null;
    }
}

export default IENotSupportedBanner;
